<template>
  <el-tabs v-model="tabIndex" @tab-click="handleTabClick" animate="">
    <el-tab-pane label="Events" name="0"></el-tab-pane>
    <el-tab-pane label="Feedback" name="1"></el-tab-pane>
    <el-tab-pane label="AI Agents" name="2"></el-tab-pane>
    <el-tab-pane label="AI Models" name="3"></el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tabIndex: {
      get() {
        return String(this.value);
      },
      set(val) {
        this.$emit("change", Number(val));
      },
    },
  },
  methods: {
    handleTabClick(tab) {
      this.$emit("change", Number(tab.name));
    },
  },
};
</script>
